/* NOVAIRE scroll reveal — drives [data-nv-reveal] (CSS lives in novaire-tokens.css).
   Ported from the mockups' theme/reveal.js; reduced-motion is handled in CSS. */
(function () {
  'use strict';

  function init() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nv-reveal]').forEach(function (el) {
        el.classList.add('nv-in');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nv-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-nv-reveal]:not(.nv-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: sections re-render without a page load.
  document.addEventListener('shopify:section:load', init);
})();
